import { BpkBox } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkProgress from '@skyscanner-internal/backpack-web/bpk-component-progress';
import BpkRating, {
  RATING_SIZES,
  RATING_SCALES,
} from '@skyscanner-internal/backpack-web/bpk-component-rating';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import BpkThemeProvider from '@skyscanner-internal/backpack-web/bpk-theming';

import { marcommsDarkSky } from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import STYLES from './index.module.scss';

const MAX_VALUE = 5;
const MIN_VALUE = 0;

export default ({
  ariaLabel,
  label,
  rating,
}: {
  rating: number;
  label: string;
  ariaLabel: string;
}) => (
  <div className={STYLES.Rating} aria-label={ariaLabel} role="status">
    <BpkBox
      display="flex"
      width="100%"
      minHeight="1.5rem"
      justifyContent="space-between"
    >
      <BpkText tagName="span" textStyle={TEXT_STYLES.footnote}>
        {label}
      </BpkText>
      {rating > 1 && (
        <BpkBox>
          <BpkRating
            ariaLabel=""
            title=""
            size={RATING_SIZES.base}
            ratingScale={RATING_SCALES.zeroToFive}
            value={rating}
          />
        </BpkBox>
      )}
    </BpkBox>
    <BpkBox width="100%">
      <BpkThemeProvider
        theme={{ progressBarFillColor: marcommsDarkSky }}
        themeAttributes={['progressBarFillColor']}
      >
        <BpkProgress
          className={STYLES.Rating__progress__theme}
          min={MIN_VALUE}
          max={MAX_VALUE}
          small
          value={rating}
          aria-label={label}
          role="progressbar"
        />
      </BpkThemeProvider>
    </BpkBox>
  </div>
);
